
export const moduleNameModuleInitialState = {

};

const MAPPED_REDUCERS = {


};

// eslint-disable-next-line default-param-last
function moduleNameReducer(state = moduleNameModuleInitialState, action) {
  const handler = MAPPED_REDUCERS[action.type];

  return handler ? handler(state, action) : state;
}

export default moduleNameReducer;
